import React from "react";
import "./Stats.css";

export const Stats = () => {
  return (
    <div className="statsBox">
      <h3>GitHub Stats</h3>
      <div>
        <div className="statsContainer">
          <div>
            <a href="https://github.com/NikeshBorkar">
              <img
                align="left"
                src="https://github-readme-streak-stats.herokuapp.com/?user=NikeshBorkar&theme=neon-dark"
                alt="NikeshBorkar Github Stats"
              />
            </a>
          </div>
        </div>

        <div className="stats-3">
          <p align="center">
            <a href="https://github.com/NikeshBorkar/github-readme-stats">
              <img
                alt="NikeshBorkar Top Languages"
                src="https://github-readme-stats-sigma-five.vercel.app/api/top-langs/?username=NikeshBorkar&langs_count=8&count_private=true&layout=compact&theme=great-gatsby&hide_border=true&bg_color=0D1117"
              />
            </a>
          </p>
        </div>

        <div className="stats-2">
          <p align="center">
            <a href="https://github.com/NikeshBorkar/github-readme-stats">
              <img
                alt="NikeshBorkar Github Stats"
                src="https://github-readme-stats-sigma-five.vercel.app/api?username=NikeshBorkar&show_icons=true&locale=en&theme=highcontrast&hide_border=true&bg_color=0D1117"
              />
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};
